import { useOutletContext } from 'react-router-dom'
import { Escalas } from 'service/api/endpoints/escalas'

export const useEscalasOutletContext = () => {
    return useOutletContext<{
        data: Escalas[]
    }>()
}
